import { render, staticRenderFns } from "./section-group.vue?vue&type=template&id=8ab9f67e&"
import script from "./section-group.vue?vue&type=script&lang=js&"
export * from "./section-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports